import deepmerge from 'deepmerge';
import type { IEnvConfigMap } from './envConfigs';
import type { DeepPartial } from '../helpers';

function isTruthy<T>(
  value: NonNullable<T> | null | undefined | false
): value is NonNullable<T> {
  return !!value;
}

const overwriteMerge = (
  _destinationArray: unknown[],
  sourceArray: unknown[],
  _options: unknown
) => sourceArray;

export const mergeConfigMaps = <T extends DeepPartial<IEnvConfigMap>>(
  configs: T,
  overridingConfigs?: T
): T =>
  deepmerge.all([{}, configs, overridingConfigs].filter(isTruthy), {
    arrayMerge: overwriteMerge,
  }) as T;
